/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-pascal-case */
import Image_Default from "../../images/man.png";
import makeFriendly from "../../modules/friendlyNumber";
import User_Button from "./User_Button";
import { useNavigate } from "react-router-dom";
import { useState,useEffect } from "react";
import {connect} from "react-redux";
import User_Button_View from "./User_Button_View";

const User = (props) => {
    const {firstName,lastName,userName,id,user} = props;
    const [followers,setFollowers] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const updateFollowers = setInterval(() => {
            getFollowers(id)
        }, 3000);
        return () => clearInterval(updateFollowers);
    },[])
    const getFollowers = (id) => {
        fetch(`/follow/number?q=${id}`)
        .then(res => res.json())
        .then(data => {
            setFollowers(data)
        })
        .catch(error => console.log(error))
    }
    const handleImageClick = () => {
        if (id == user.id) {
            navigate("/profile")
        } else {
            navigate(`/profile/${id}`)
        }
    }
    const handleNameClick = () => {
        if (id == user.id) {
            navigate("/profile")
        } else {
            navigate(`/profile/${id}`)
        }
    }
    return(
        <div className={`user_div  background_change_hover background_change_hover_${props.color_background}`}>
            <div className="user_info">
                <img onClick={handleImageClick} src={Image_Default} alt="User" className="user_image user_image_user" />
                <div className="user_desc">
                    <div onClick={handleNameClick} className="name">{firstName} {lastName}</div>
                    <div className="username">@{userName} {makeFriendly(followers)}</div>
                </div>
            </div>
            {
                id != user.id ? 
                <User_Button 
                    id={id} 
                /> : 
                <User_Button_View />
            }
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background,
        user: state.getUser.user
    }
}
export default connect(mapStateToProps)(User);